<template>
  <div class="form-group">
    <div class="form-row">
      <label for="kpi">KPI</label>
      <input id="kpi" class="form-control" type="text" v-model="editedAdjustment.kpi"/>
    </div>
    <div class="form-row">
      <label for="title">Titel</label>
      <input id="title" class="form-control" type="text" v-model="editedAdjustment.title"/>
    </div>
    <div class="form-row">
      <label for="value">Betrag</label>
      <input id="value" class="form-control" type="number" v-model="editedAdjustment.value"/><br/>
    </div>
    <div class="mt-3 text-right">
      <div class="btn btn-success" @click="$emit('input', editedAdjustment)">Speichern</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Object
  },
  data() {
    return {
      editedAdjustment: {
        kpi: 'netIncome',
        title: '',
        value: 0.0
      }
    }
  },
  mounted() {
    if (this.value)
      this.editedAdjustment = {...this.value}
  }
}
</script>
